'use client'

import { useTranslations } from 'next-intl'
import dynamic from 'next/dynamic'
import { ReactNode, useEffect } from 'react'

import { SlideInBody } from '@pearlconvert/ui/components/slide-in'
import { useModals } from '@pearlconvert/ui/providers/modals/modals.context'

import '@maestro/commerce-blocks/components/wishlist/styles/wishlist.scss'

const WishlistItemsList = dynamic(
  () =>
    import('@maestro/commerce-blocks/components/wishlist/wishlist-items-list')
)

function WishlistModalContent({ children }: { children: ReactNode }) {
  return (
    <SlideInBody>
      <div className="wishlist__content">{children}</div>
    </SlideInBody>
  )
}

export default function Wishlist({
  isWishlistPage = false,
}: {
  isWishlistPage?: boolean
}) {
  const t = useTranslations('commerce-blocks')
  const { addModal } = useModals()

  useEffect(() => {
    addModal({
      key: 'wishlist',
      hash: 'wishlist',
      Component: (
        <WishlistModalContent>
          <WishlistItemsList />
        </WishlistModalContent>
      ),
      props: {
        title: t('_globals.wishlist'),
        customClassName: 'wishlist',
        hasBackButton: false,
      },
    })
  }, [addModal, t])

  return <>{isWishlistPage && <WishlistItemsList />}</>
}
